import * as tslib_1 from "tslib";
import * as React from 'react';
import { StyledIconBase } from '../../StyledIconBase';
export var BookOpen = React.forwardRef(function (props, ref) {
    var attrs = {
        "fill": "currentColor",
    };
    return (React.createElement(StyledIconBase, tslib_1.__assign({ iconAttrs: attrs, iconVerticalAlign: "middle", iconViewBox: "0 0 24 24" }, props, { ref: ref }),
        React.createElement("path", { d: "M19.92 3.029h-.004c-2.944.132-6.288.612-7.916 1.984-1.628-1.372-4.972-1.852-7.916-1.983a1.962 1.962 0 0 0-1.466.55A2.016 2.016 0 0 0 2 5.028v11c0 1.06.842 1.938 1.917 1.998 4.861.27 7.354 2.661 7.38 2.685l.007-.007c.09.088.19.166.311.217a1.005 1.005 0 0 0 1.089-.209c.025-.024 2.519-2.415 7.38-2.685 1.074-.062 1.916-.94 1.916-2v-11c0-1.101-.893-1.998-2.08-1.998zm.052 12.999c-3.22.179-5.543 1.169-6.972 2.013V7c0-.804 2.455-1.769 7-1.972l-.028 11z", key: "k0" })));
});
BookOpen.displayName = 'BookOpen';
export var BookOpenDimensions = { height: 24, width: 24 };
